/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  EmpAttendance
} from '../../schema'


/**
 * List all attendances of an employee
 */
export const retrieveEmpAttendance = (
    employeeId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmpAttendance>> => {
    return axios.get(
      `/empattendances/${employeeId}`,options
    );
  }


export const getRetrieveEmpAttendanceQueryKey = (employeeId: string,) => [`/empattendances/${employeeId}`];

    
export type RetrieveEmpAttendanceQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveEmpAttendance>>>
export type RetrieveEmpAttendanceQueryError = AxiosError<unknown>

export const useRetrieveEmpAttendance = <TData = Awaited<ReturnType<typeof retrieveEmpAttendance>>, TError = AxiosError<unknown>>(
 employeeId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveEmpAttendance>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveEmpAttendanceQueryKey(employeeId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveEmpAttendance>>> = ({ signal }) => retrieveEmpAttendance(employeeId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof retrieveEmpAttendance>>, TError, TData>(queryKey, queryFn, {enabled: !!(employeeId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

